export class IncomeApproachLayout {
	public sections = [
		{
			title: 'General',
			items: [
				[
					{
						cssClass: 'col-md-12',
						type: 'static-table',
						options: {
							rows: [
								{
									cols: [
										{ 
											colSpan: 2,
											options: { label: 'Estimated Market Rent' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVIncomeAnalysisEstimatedMarketMonthlyRentAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{
											colSpan: 2,
											options: { label: 'x Gross Rent Multiplier' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVIncomeAnalysisGrossRentMultiplierFactor',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											colSpan: 2,
											options: { label: 'Indicated Value' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVIncomeAnalysisValueIndicatedByIncomeApproachAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Comments',
			items: [
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVIncomeAnalysisIncomeAnalysisComment',
							show: {
								label: false
							}
						}
					}
				]
			]
		}
	];
}